export default __webpack_public_path__ + "static/1436-857efc435146d2ecdd3cae7909b46981.gif";